import moment from 'moment';

// Date in seconds
export const formatDuration: (duration: number) => string = (duration) => {
  const asDuration = moment.duration(duration, 'seconds');

  const years = Math.floor(asDuration.asYears());
  const months = asDuration.months();
  const days = asDuration.days();
  const hours = asDuration.hours();
  const minutes = asDuration.minutes();
  const secs = asDuration.seconds();

  const parts: string[] = [];

  if (years > 0) parts.push(`${years}y`);
  if (months > 0) parts.push(`${months}mo`);
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  if (secs > 0 || parts.length === 0) parts.push(`${secs}s`); // Ensure seconds show up if no other units

  return parts[0] + ', ' + parts[1];
};

export enum timeZone {
  UTC = 'UTC',
  GMT = 'GMT',
  PST = 'PST',
  PDT = 'PDT',
  MST = 'MST',
  MDT = 'MDT',
  CST = 'CST',
  CDT = 'CDT',
  EST = 'EST',
  EDT = 'EDT',
  IST = 'IST',
  CET = 'CET',
  EET = 'EET',
  JST = 'JST',
  AEST = 'AEST',
  AEDT = 'AEDT',
}

export const enumTimeZoneMap: Record<timeZone, string> = {
  [timeZone.UTC]: 'UTC',
  [timeZone.GMT]: 'GMT',
  [timeZone.PST]: 'America/Los_Angeles',
  [timeZone.PDT]: 'America/Los_Angeles',
  [timeZone.MST]: 'America/Denver',
  [timeZone.MDT]: 'America/Denver',
  [timeZone.CST]: 'America/Chicago',
  [timeZone.CDT]: 'America/Chicago',
  [timeZone.EST]: 'America/New_York',
  [timeZone.EDT]: 'America/New_York',
  [timeZone.IST]: 'Asia/Kolkata',
  [timeZone.CET]: 'Europe/Paris',
  [timeZone.EET]: 'Europe/Athens',
  [timeZone.JST]: 'Asia/Tokyo',
  [timeZone.AEST]: 'Australia/Sydney',
  [timeZone.AEDT]: 'Australia/Sydney',
};

export const timeZones: timeZone[] = Object.values(timeZone);

export const dateFormat: (date: Date, timezone: timeZone) => string = (date, timezone) => {
  return moment(date).tz(enumTimeZoneMap[timezone]).format('YYYY-MM-DD') + ' ' + timezone;
};

export const dateTimeFormat: (date: Date, timezone: timeZone) => string = (date, timezone) => {
  return moment(date).tz(enumTimeZoneMap[timezone]).format('YYYY-MM-DD HH:mm') + ' ' + timezone;
};

export const SecondsSince = (date: Date) => {
  return new Date().getTime() / 1000 - date.getTime() / 1000;
};

export const TimeSince = (date: Date) => {
  const secondsToAgoString = (seconds: number): string => {
    const intervals: [number, string][] = [
      [Math.floor(seconds / 31536000), 'year'],
      [Math.floor((seconds % 31536000) / 2592000), 'month'],
      [Math.floor((seconds % 2592000) / 86400), 'day'],
      [Math.floor((seconds % 86400) / 3600), 'hour'],
      [Math.floor((seconds % 3600) / 60), 'minute'],
      [Math.floor(seconds % 60), 'second'],
    ];

    const largestInterval = intervals.find(([amount]) => amount > 0);

    if (largestInterval) {
      const [amount, unit] = largestInterval;
      return `${amount} ${unit}${amount !== 1 ? 's' : ''} ago`;
    }

    return 'just now';
  };

  return secondsToAgoString(SecondsSince(date));
};
